module.exports = __webpack_public_path__ + "static/media/p4.7b73bc72.png";